export const screenshotModThemeColors = {
	light: {
		error: "rgb(186, 26, 26)",
		scrim: "rgb(0, 0, 0)",
		shadow: "rgb(0, 0, 0)",
		onError: "rgb(255, 255, 255)",
		outline: "rgb(118, 118, 128)",
		primary: "rgb(74, 88, 169)",
		surface: "rgb(255, 251, 255)",
		backdrop: "rgba(47, 48, 56, 0.4)",
		tertiary: "rgb(119, 83, 109)",
		elevation: {
			level0: "transparent",
			level1: "rgb(246, 243, 251)",
			level2: "rgb(241, 238, 248)",
			level3: "rgb(235, 233, 246)",
			level4: "rgb(233, 231, 245)",
			level5: "rgb(230, 228, 243)",
		},
		onPrimary: "rgb(255, 255, 255)",
		onSurface: "rgb(27, 27, 31)",
		secondary: "rgb(0, 107, 95)",
		background: "rgb(240, 237, 241)",
		onTertiary: "rgb(255, 255, 255)",
		onSecondary: "rgb(255, 255, 255)",
		premiumChip: {
			color: "#E65100",
			background: "rgba(251, 192, 45, 0.5)",
		},
		onBackground: "rgb(27, 27, 31)",
		errorContainer: "rgb(255, 218, 214)",
		inversePrimary: "rgb(187, 195, 255)",
		inverseSurface: "rgb(48, 48, 52)",
		outlineVariant: "rgb(199, 197, 208)",
		surfaceVariant: "rgb(227, 225, 236)",
		surfaceDisabled: "rgba(27, 27, 31, 0.12)",
		inverseOnSurface: "rgb(243, 240, 244)",
		onErrorContainer: "rgb(65, 0, 2)",
		onSurfaceVariant: "rgb(70, 70, 79)",
		primaryContainer: "rgb(222, 224, 255)",
		onSurfaceDisabled: "rgba(27, 27, 31, 0.38)",
		tertiaryContainer: "rgb(255, 215, 241)",
		onPrimaryContainer: "rgb(0, 15, 93)",
		secondaryContainer: "rgb(95, 250, 228)",
		onTertiaryContainer: "rgb(45, 18, 39)",
		onSecondaryContainer: "rgb(0, 32, 28)",
	},
	dark: {
		error: "rgb(255, 180, 171)",
		scrim: "rgb(0, 0, 0)",
		shadow: "rgb(0, 0, 0)",
		onError: "rgb(105, 0, 5)",
		outline: "rgb(144, 144, 154)",
		primary: "rgb(187, 195, 255)",
		surface: "rgb(27, 27, 31)",
		backdrop: "rgba(47, 48, 56, 0.4)",
		tertiary: "rgb(230, 186, 215)",
		elevation: {
			level0: "transparent",
			level1: "rgb(35, 35, 42)",
			level2: "rgb(40, 40, 49)",
			level3: "rgb(45, 46, 56)",
			level4: "rgb(46, 47, 58)",
			level5: "rgb(49, 51, 62)",
		},
		onPrimary: "rgb(24, 39, 120)",
		onSurface: "rgb(228, 225, 230)",
		secondary: "rgb(56, 221, 200)",
		background: "rgb(14, 14, 17)",
		onTertiary: "rgb(69, 38, 61)",
		onSecondary: "rgb(0, 55, 49)",
		premiumChip: {
			color: "#FFFFFF",
			background: "rgba(255, 152, 0, 0.5)",
		},
		onBackground: "rgb(228, 225, 230)",
		errorContainer: "rgb(147, 0, 10)",
		inversePrimary: "rgb(74, 88, 169)",
		inverseSurface: "rgb(228, 225, 230)",
		outlineVariant: "rgb(70, 70, 79)",
		surfaceVariant: "rgb(70, 70, 79)",
		surfaceDisabled: "rgba(228, 225, 230, 0.12)",
		inverseOnSurface: "rgb(48, 48, 52)",
		onErrorContainer: "rgb(255, 180, 171)",
		onSurfaceVariant: "rgb(199, 197, 208)",
		primaryContainer: "rgb(50, 63, 144)",
		onSurfaceDisabled: "rgba(228, 225, 230, 0.38)",
		tertiaryContainer: "rgb(93, 60, 84)",
		onPrimaryContainer: "rgb(222, 224, 255)",
		secondaryContainer: "rgb(0, 80, 71)",
		onTertiaryContainer: "rgb(255, 215, 241)",
		onSecondaryContainer: "rgb(95, 250, 228)",
	},
} as const;
